import { api } from "@shared/lib/api";
import { BackednResponse } from "@shared/lib/types";
import {
  IGetAddRightsQuery,
  IGetAddRightsResponse,
} from "@shared/lib/types/addRightsType";
import { AddRightsStatusEnum } from "../constants";

export class AddRightsService {
  public static async getAddRights(query: IGetAddRightsQuery) {
    const response = (await api
      .post("ad-rights/search", {
        json: {
          ...query,
          statuses: query.status?.includes(AddRightsStatusEnum.All)
            ? []
            : query.status,
        },
      })
      .json()) as BackednResponse<IGetAddRightsResponse>;
    return response;
  }
  public static async getAddRightsByBriefInfluencerId(
    briefInfluencerId: string
  ) {
    const response = (await api
      .post("ad-rights/search", {
        json: {
          briefInfluencerIds: [briefInfluencerId],
          limit: 100,
        },
      })
      .json()) as BackednResponse<IGetAddRightsResponse>;
    return response;
  }

  public static async uploadAdRightsMediaLink (adRightsTrackerId: string, mediaLink?: string, downloadableMediaUrls?: string[]) {
    return await api.post("ad-rights/add-media-link", {
      json: {
        adRightsTrackerId,
        mediaLink,
        downloadableMediaUrls
      }
    }).json() as BackednResponse<IGetAddRightsResponse>;
  }

  public static async startAdRight(
    adRightsTrackerId: string,
    startDate: string
  ) {
    const response = await api
      .post("ad-rights/start-date", {
        json: {
          adRightsTrackerId,
          startDate,
        },
      })
      .json();
    return response;
  }
}
